import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {sendStartupWelcomeEmail} from 'src/openapi/admin/apis/UsersEmailsApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    userId: number,
};

export const useSendStartupWelcomeEmail = ({userId}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback(
        () => apiDispatch(sendStartupWelcomeEmail({userId})),
        [userId, apiDispatch],
    );

    return useCommonEventHook({eventAction});
};
